// Walks the cfg tree; strips {{ and }} pairs to not surface them as placeholders.
export function extractPlaceholders(cfg: unknown): string[] {
  const tokens = new Set<string>();
  const visit = (v: unknown) => {
    if (typeof v === 'string') {
      const stripped = v.replace(/\{\{|\}\}/g, '');
      for (const m of stripped.matchAll(/\{[_A-Za-z][_A-Za-z0-9-]*\}/g)) {
        tokens.add(m[0].slice(1, -1));
      }
    } else if (Array.isArray(v)) v.forEach(visit);
    else if (v && typeof v === 'object') Object.values(v as object).forEach(visit);
  };
  visit(cfg);
  return [...tokens].sort();
}
